<template>
  <div class="container">
    <!-- TODO - INCLUDE RUNNING AVERAGES OF BLOCKS COMPLETED - Last 7 and 30 days -->
    <!-- Log category completion, as well as total percent of time -->
    <template v-if="!isMobile()">
      {{ numCompleted }} blocks completed
      <br />
      {{ numQuotaCompleted }}/{{ quota }} quota blocks completed - {{ isFinite(percentage) ? percentage : "0" }}%
      <br />
      {{ isFinite(dayEfficiency) ? dayEfficiency : "0" }}% day efficiency
      <br />
      <br />
      {{ isFinite(runningEfficiency) ? runningEfficiency : "0" }}% running efficiency
    </template>
    <template v-else>
      <!-- TODO - Add TAP FUNCTIONALITY (CYCLE THROUGH STATS, SHOW MODAL, ETC) -->
      {{ isFinite(runningEfficiency) ? runningEfficiency : "0" }}%
      <br />
      <span class="mobileDescription">Running Efficiency</span>
    </template>
  </div>
</template>

<script>
import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "day-summary",
  props: ["categories"],
  mixins: [util.getMobileMixin()],
  data() {
    return {
      now: Date.now(),
    };
  },
  created() {
    setInterval(() => {
      this.$data.now = Date.now();
    }, 5000);
  },
  computed: {
    numCategories() {
      return Object.keys(this.categories).length;
    },
    numCompleted() {
      let numCompleted = 0;
      for (let category in this.categories) {
        if (!this.categories[category].blocks) continue;
        numCompleted += Object.keys(this.categories[category].blocks).length;
      }
      return numCompleted;
    },
    numQuotaCompleted() {
      let numCompleted = 0;
      for (let category in this.categories) {
        if (!this.categories[category].blocks) continue;
        let numBlocks = Object.keys(this.categories[category].blocks).length;
        numCompleted += Math.min(numBlocks, categoryUtil.getQuota(category, util.getCurrentDay(), false));
      }
      return numCompleted;
    },
    quota() {
      let quota = 0;
      for (let category in this.categories) {
        quota += categoryUtil.getQuota(category, util.getCurrentDay(), false);
      }
      return quota;
    },
    percentage() {
      return Math.round((this.numQuotaCompleted / this.quota) * 1000) / 10;
    },
    dayEfficiency() {
      return Math.round((this.numCompleted / 32) * 1000) / 10;
    },
    runningEfficiency() {
      //FIXME - WE NEED TO TIMEOUT MAGIC HERE
      //STARTING AT 5AM BECAUSE #db.js
      //(or is this actually 6am?)
      let hoursElapsed = new Date(this.now).getHours() - 5;

      if (hoursElapsed <= 0) {
        hoursElapsed += 24;
      }

      //Max out at 32 blocks - we need sleep!
      let potentialBlocks = hoursElapsed < 16 ? hoursElapsed * 2 : 32;

      return Math.round((this.numCompleted / potentialBlocks) * 1000) / 10;
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 2rem;
}

@media (max-width: 600px) {
  .container {
    margin-top: 0;
    padding: 0.5rem;
    border-left: 1px solid #eee;
  }
  .mobileDescription {
    font-size: 0.7rem;
  }
}
</style>



// WEBPACK FOOTER //
// DaySummary.vue?56ed7162